<script setup lang="ts">
import { onMounted, ref } from 'vue';
import renderMathInElement from 'katex/dist/contrib/auto-render.min.js'
import 'katex/dist/katex.min.css';

const katexRef = ref<HTMLElement | null>(null)
onMounted(() => {
    if (!katexRef.value) return;

    renderMathInElement(katexRef.value, {
        // customised options
        // • auto-render specific keys, e.g.:
        delimiters: [
            { left: '$$', right: '$$', display: true },
            { left: '$', right: '$', display: false },
            { left: '\\(', right: '\\)', display: false },
            { left: '\\[', right: '\\]', display: true }
        ],
        // • rendering keys, e.g.:
        throwOnError: false
    })
})
</script>

<template>
    <div ref="katexRef">
        <slot></slot>
    </div>
</template>